export function formatRelativeTime(value: string | null | undefined): string {
  if (!value) return "尚未更新";
  const timestamp = Date.parse(value);
  if (!Number.isFinite(timestamp)) return "更新时间未知";

  const seconds = Math.max(0, Math.round((Date.now() - timestamp) / 1000));
  if (seconds < 60) return "刚刚更新";
  if (seconds < 3600) return `${Math.floor(seconds / 60)} 分钟前`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} 小时前`;
  return `${Math.floor(seconds / 86400)} 天前`;
}

export function formatScore(score: number): string {
  if (score >= 10_000) return `${(score / 10_000).toFixed(1)}万`;
  if (score >= 1_000) return `${(score / 1_000).toFixed(1)}千`;
  return score.toFixed(2);
}
